import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslationService } from 'src/app/services/translation.service';
import { ExamFolderService } from 'src/app/services/exam-folder.service';
import { FormsSetupService } from 'src/app/services/forms-setup.service';
import { ExamService } from 'src/app/services/exam.service';
import { AudioService } from 'src/app/services/audio.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkDragDrop,CdkDrag, CdkDropList, CdkDropListGroup, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-forms-setup',
  standalone: true,
  imports: [CommonModule, FormsModule,DragDropModule,CdkDropListGroup, CdkDropList, CdkDrag],
  templateUrl: './forms-setup.component.html',
  styleUrls: ['./forms-setup.component.css']
})
export class FormsSetupComponent {
  constructor(public translationService: TranslationService, private examFolderService: ExamFolderService, private formSetup: FormsSetupService,private examService: ExamService, public audioService: AudioService) {}

  allExamFolders: any[] = [];
  questionTypes: any[] = ['MultiAnswers', 'MCQ', 'TF', 'MCQImages', 'RightOrWrongImage', 'RightOrWrongVideo', 'Ordering'];
  
  unitsList: any[] = []; 
  totalQuestions: number = 0;
  FormGenerating: boolean = false;
  FormQuestions: any[] = [];
  FormNumbers = [1,2,3,4,5,6,7,8,9,10,11,12];
  selectedFormNo: number = 0;
  activeTab: string = 'new';
  selectedFolderName: string = '';
  Level_BASE: any[] = [];

  AllExamForms: any[] = [];
  FormIDs: any[] = [];
  languagesList: any[] = [];
  filteredLanguagesList: any[] = [];
  selectedFormlanguage: string = '';

  selectedQuestion: any;
  updateItem: any;
  showViewModal: boolean = false;

  getImageLink: string = 'https://exam.alarkkan.app/data/img/';
  getVideoLink: string = 'https://exam.alarkkan.app/data/vdo/';
  
  isExamCompleted: boolean = false;
  username = localStorage.getItem('username') || 'Candidate Name';
  examAttendanceNumber: number = 0;
  showTestExam: boolean = false;
  QuestionContent: any;
  AnswersDto: any[] = [];
  currentQuestionText: string = '';
  selectedAnswer: any;
  selectedAnswers: any[] = [];  // Ordering and MulitAnswers questions type
  currentQuestionIndex: number = 0;
  progressPercentage: number = 0;
  remainingTime: number = 5400; // 1:30 hour
  remainingTimePerQuestion: number = 90; // 1:30 minute
  timerInterval: any;

  postponeCount: number = 3
  skipThisQuestion: any = {};
  skipCount: number = 3
  
  setActiveTab(tab: string) {
    this.activeTab = tab;
    this.FormQuestions = [];
    this.Level_BASE= [];
    this.selectedFormNo = 0;
    this.selectedFolderName = '';
    this.selectedFormlanguage = '';
    this.unitsList = [];
    this.totalQuestions = 0;
  }

  ngOnInit() {
    this.loadFolders();
    this.getAllForms();
    this.getLanguages();
  }

  loadFolders() {
    this.examFolderService.getFolders().subscribe((response) => {
      this.allExamFolders = response.result[0] || [];
    });
  }
  
  getQuestionCountForUnit(unit: any, type: string): number {
    const question = unit.QuestionDetails?.find((q: { QuestionType: string; }) => q.QuestionType === type);
    return question ? question.QuestionCount : 0;
  }

  onFolderChange(folderId: number) {
    const selectedFolder = this.allExamFolders.find(f => f.ID == folderId);
    if (selectedFolder) {
      this.unitsList = JSON.parse(selectedFolder.UnitsDetails);
      this.updateTotalQuestions(); 
    }
    this.selectedFolderName = selectedFolder["Course Name"];
    const selectedForm = this.AllExamForms.find(f => f.CourseName === this.selectedFolderName);

    this.FormIDs = selectedForm?.FormIDs 
      ? [...new Set(selectedForm.FormIDs.split(',').map((id: string) => +id.trim()))] 
      : [];

    this.FormIDs = this.FormIDs.sort((a, b) => a - b);
  }

  validateItemPerUnit(event: any, unit: any) {
    let value = event.target.value.replace(/\D/g, '');
    if (value.length > 2) {
      value = value.slice(0, 2);
    }
  
    let intValue = value ? parseInt(value, 10) : 0;
  
    let totalItemPerUnit = this.unitsList.reduce((sum, u) => sum + (u['Item Per Unit'] || 0), 0);
    let maxAllowedForCurrentUnit = 50 - totalItemPerUnit + (unit['Item Per Unit'] || 0);
  
    if (intValue > maxAllowedForCurrentUnit) {
      intValue = maxAllowedForCurrentUnit;
    }
  
    unit['Item Per Unit'] = intValue;
    event.target.value = intValue;
  
    this.resetQuestionTypes(unit);
    this.updateTotalQuestions();
  }
  
  validateQuestionTypeInput(event: any, unit: any, type: string) {
    let value = event.target.value.replace(/\D/g, '');
    let maxAllowed = unit['Item Per Unit'];
    let totalAllocated = this.getTotalAllocated(unit, type);
  
    if (value.length > 2) {
      value = value.slice(0, 2);
    }
  
    let intValue = value ? parseInt(value, 10) : 0;
    
    if (totalAllocated + intValue > maxAllowed) {
      intValue = maxAllowed - totalAllocated;
    }
  
    unit[type] = intValue;
    event.target.value = intValue;
    this.updateTotalQuestions();
  }
  
  resetQuestionTypes(unit: any) {
    this.questionTypes.forEach(type => {
      unit[type] = 0;
    });
  }
 
  getTotalAllocated(unit: any, excludeType: string = ''): number {
    return this.questionTypes.reduce((sum, type) => 
      sum + (type !== excludeType ? (unit[type] || 0) : 0), 0);
  }
  
  updateTotalQuestions() {
    this.totalQuestions = this.unitsList.reduce((sum, unit) => 
      sum + this.getTotalAllocated(unit), 0);
  }  

  generateQuestions() {
    this.FormGenerating = true;
    this.FormQuestions = [];
    const levelsCount = {
      Easy: 20,
      Medium: 15,
      Hard: 5,
      "Very Easy": 10
    };
  
    const result = this.unitsList.reduce((acc, unit) => {
      const types = [
        { QuestionType: "TF", NumberOfQuestion: unit.TF || 0 },
        { QuestionType: "MCQ", NumberOfQuestion: unit.MCQ || 0 },
        { QuestionType: "MultiAnswers", NumberOfQuestion: unit.MultiAnswers || 0 },
        { QuestionType: "MCQImages", NumberOfQuestion: unit.MCQImages || 0 },
        { QuestionType: "RightOrWrongImage", NumberOfQuestion: unit.RightOrWrongImage || 0 },
        { QuestionType: "RightOrWrongVideo", NumberOfQuestion: unit.RightOrWrongVideo || 0 },
        { QuestionType: "Ordering", NumberOfQuestion: unit.Ordering || 0 }
      ];
  
      types.forEach(({ QuestionType, NumberOfQuestion }) => {
        acc.push(...Array(NumberOfQuestion).fill({ UnitID: unit.UnitId, QuestionType }));
      });
  
      return acc;
    }, []);
  
    const getRandomLevel = () => {
      const availableLevels = Object.keys(levelsCount).filter(level => levelsCount[level as keyof typeof levelsCount] > 0);
      if (availableLevels.length === 0) return null;
  
      const randomIndex = Math.floor(Math.random() * availableLevels.length);
      const selectedLevel = availableLevels[randomIndex];
  
      levelsCount[selectedLevel as keyof typeof levelsCount]--;
      return selectedLevel;
    };
  
    const addedQuestionIDs = new Set<number>();

    const fetchQuestion = (UnitID: number, QuestionType: string, questionLevel: string, languageID: number) => {
      this.formSetup.getQuestions(UnitID, QuestionType, questionLevel, languageID).subscribe((response) => {
        const question = response.result[0]?.[0];
    
        if (question) {
          if (addedQuestionIDs.has(question.QuestionID)) {
            fetchQuestion(UnitID, QuestionType, questionLevel, languageID); 
          } else {
            const unit = this.unitsList.find(u => u.UnitId === question.UnitID);
            if (unit) question.UnitName = unit["Unit Name"];
            this.FormQuestions.push(question);
            addedQuestionIDs.add(question.QuestionID);
          }
        }

        const levelOrder = ["Hard", "Medium", "Easy", "Very Easy"];
        this.FormQuestions.sort((a, b) => {
          return levelOrder.indexOf(a.QuestionLevel) - levelOrder.indexOf(b.QuestionLevel);
        });

        let counts: { [key: string]: number } = {};
        this.FormQuestions.forEach((question: any) => {
          counts[question.QuestionLevel] = (counts[question.QuestionLevel] || 0) + 1;
        });
        this.Level_BASE = Object.entries(counts).map(([key, value]) => ({
          level: key,
          count: value
        }));

      });
    };
    
    result.forEach(({ UnitID, QuestionType }: { UnitID: number, QuestionType: string }) => {
      const questionLevel = getRandomLevel();
      if (questionLevel) {
        fetchQuestion(UnitID, QuestionType, questionLevel, 2);
      }
    });

    this.FormNumbers = this.AllExamForms.find(f => f.CourseName === this.selectedFolderName)?.FormNumbers || [];
    this.selectedFormNo = this.FormNumbers[0];
  }
  
  viewItem(item: any) {
    this.selectedQuestion = item;
  
    this.formSetup.getAnswersByQuestionID(item.QuestionID).subscribe((response) => {
      item.Answers = response.result[0] || [];
    
      if (this.selectedQuestion.QuestionType === 'Ordering' && item.Answers.length > 0) {
  
        item.Answers = item.Answers.flatMap((answer: any) => {
          if (!answer.AnswerText) return [];
  
          const cleanedText = answer.AnswerText.trim();
          const splitText = cleanedText.split(',').map((text: string) => text.trim());
          const splitImages = (answer.ImageLink || "").split(',').map((image: string) => image.trim());


          if (splitText[0].startsWith("Ordering Ordering")) {
            splitText[0] = splitText[0].replace("Ordering Ordering", "").trim();
          } else if (splitText[0].startsWith("Ordering")) {
            splitText[0] = splitText[0].replace("Ordering", "").trim();
          }
  
          return splitText.map((word: string, index: number) => ({
            AnswerID: `${answer.AnswerID}-${index}`, 
            AnswerText: word,
            IsCorrect: answer.IsCorrect,
            ImageLink: splitImages[index] || null,
          }));
        });
        }
  
      this.showViewModal = true;
    });
  
    this.selectedFormlanguage = this.filteredLanguagesList.find((lang: any) => lang.LanguageID === this.selectedQuestion.LanguageID)?.LanguageName;
  
    if (this.FormQuestions?.length > 0) {
      this.FormQuestions.forEach((question: any) => {
        const unit = this.unitsList.find(u => u.UnitId == question.UnitID);
        if (unit) {
          question.UnitName = unit["Unit Name"];
        }
      });
    }
  }
  
  playAudio(text: string, language: string): void {
    if (Number(language)) {
      language = this.filteredLanguagesList.find((lang: any) => lang.LanguageID == language)?.LanguageName;
    }

    language = this.filteredLanguagesList.find((lang: any) => lang.LanguageName === language)?.ShortName;
    this.audioService.textToAudio(text, language).subscribe({
      next: (audioBlob: Blob) => {
        const audioSrc = URL.createObjectURL(audioBlob);
        const audio = new Audio(audioSrc);
        audio.play()
      }
    });
  }

  closeModal() {
    this.showViewModal = false;
    this.showTestExam = false;
    this.ngOnDestroy();
  }
  
  refreshForm() {
    this.FormQuestions = [];
    this.Level_BASE = [];
    this.generateQuestions();
  }

  backToFormSetup() {
    this.FormGenerating = false;
    this.FormQuestions = [];
    this.Level_BASE = [];
  }

  refreshQuestion(item: any) {
    this.getUpdatedItem(item.UnitID, item.QuestionType, item.QuestionLevel)
      .then(() => {
        const questionIDs = this.FormQuestions.map((q: { QuestionID: any }) => q.QuestionID);
  
        if (!questionIDs.includes(this.updateItem.QuestionID)) {
          this.FormQuestions = this.FormQuestions.map((question: any) =>
            question.QuestionID === item.QuestionID ? this.updateItem : question
          );
  
          if (this.FormQuestions && this.FormQuestions.length > 0) {
            this.FormQuestions.forEach((question: any) => {
              const unit = this.unitsList.find(u => u.UnitId == question.UnitID);
              if (unit) {
                question.UnitName = unit["Unit Name"];
              }
            });
          }
        }
      })
  }
  
  getUpdatedItem(unitId: number, questionType: string, questionLevel: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.formSetup.updateItemInForm(unitId, questionType, questionLevel)
        .subscribe(
          (response) => {
            this.updateItem = response.result[0][0];
            resolve();
          },
          (error) => {
            reject(error);
          }
        );
    });
  }
  
  saveForm() { 
    let QuestionIDs: { QuestionID: any; }[] = [];
    this.FormQuestions.forEach((question: any) => {
      QuestionIDs.push({ QuestionID: question.QuestionID });
    });

    let questionIDNumbers = QuestionIDs.map((q: { QuestionID: any; }) => q.QuestionID);
    this.formSetup.updateFormNoForQuestions(Number(this.selectedFormNo), questionIDNumbers).subscribe((response) => {
      if (response.success === true) {
        this.FormGenerating = false;
        this.loadFolders();
        this.getAllForms();
        this.FormQuestions = [];
        this.Level_BASE = [];
        this.unitsList = [];
        this.totalQuestions = 0
      }
    });
  }
  
  getAllForms() {
    this.formSetup.getAllForms().subscribe((response) => {
      this.AllExamForms = response.result[0];
      this.AllExamForms.forEach((course: any) => {
        const formIDs = course.FormIDs ? course.FormIDs.split(',').map((id: string) => +id.trim()) : [];
        course.FormNumbers = this.FormNumbers.filter((num: number) => !formIDs.includes(num));
      });
    });
  }

  getLanguages() {
    this.examService.getLanguageList().subscribe((response) => {
        this.languagesList = response.result[0].map((language: { LanguageName: any; ShortName: any; LanguageID: any }) => ({
          LanguageID : language.LanguageID,
          LanguageName: language.LanguageName,
          ShortName: language.ShortName
        }));

        const desiredLanguages = ["Arabic", "English", "Urdu (Pakistan)", "Bengali (Bangladesh)" , "Hindi (India)" , "Nepali (Nepal)" , "Malayalam" , "Tamil (India)" , "Filipino" , "Indonesian (Indonesia)" , "Turkish (Turkey)"];
        this.filteredLanguagesList = this.languagesList.filter(lang => desiredLanguages.includes(lang.LanguageName));
      },
    );
  }
  
  getQuestions() {
    const selectedFolder = this.allExamFolders.find(f => f["Course Name"] === this.selectedFolderName);
    const selectedFolderID = selectedFolder ? selectedFolder.ID : null;
  
    if (!this.selectedFormNo || !this.selectedFormlanguage || !selectedFolderID) {
      return;
    }
  
    this.FormQuestions = [];
    this.Level_BASE = [];
  
    this.getQuestionsByCourseAndForm(Number(selectedFolderID),  Number(this.selectedFormNo), Number(this.selectedFormlanguage));
  }
  
  getQuestionsByCourseAndForm(CourseID: number, FormNo: number, LangID: number) {
    this.formSetup.getQuestionsByCourseAndForm(CourseID, FormNo, LangID).subscribe((response) => {
      
      this.FormQuestions = response.result?.[0] || [];
      this.Level_BASE = [];
  
      let counts: { [key: string]: number } = {};
      this.FormQuestions.forEach((question: any) => {
        counts[question.QuestionLevel] = (counts[question.QuestionLevel] || 0) + 1;
      });
  
      this.Level_BASE = Object.entries(counts).map(([key, value]) => ({
        level: key,
        count: value
      }));
    });
  }

  startTestExam() {
    if (this.FormQuestions.length > 0) {
      this.totalQuestions = this.FormQuestions.length;
      this.FormQuestions = this.FormQuestions.sort(() => Math.random() - 0.5);
      this.loadQuestion(0);
      this.startTimer();
      this.examAttendanceNumber = Math.floor(Math.random() * 1000000);
    }
    this.remainingTime = 5400;
    this.remainingTimePerQuestion = 90
  }

  loadQuestion(index: number) {
    this.showTestExam = true;
    const currentQuestionData = this.FormQuestions[index];
    this.QuestionContent = { ...currentQuestionData }; 
    this.currentQuestionText = currentQuestionData.QuestionText;
    this.currentQuestionIndex = index; 
    this.progressPercentage = ((index + 1) / this.totalQuestions) * 100;
  
    if (this.QuestionContent.QuestionType !== 'Ordering') {
      this.formSetup.getAnswersByQuestionID(currentQuestionData.QuestionID).subscribe((response) => {
        this.AnswersDto = response.result[0];
        this.AnswersDto = this.AnswersDto.sort(() => Math.random() - 0.5);
      });


      if (this.QuestionContent.QuestionType === 'RightOrWrongVideo') {
        this.QuestionContent.VideoLink = currentQuestionData.VideoLink;
        this.remainingTimePerQuestion = 150; 
        this.remainingTime = this.remainingTime + 60; 
      }
  
      const videoElement = document.getElementById('questionVideo') as HTMLVideoElement;
      if (videoElement) {
        videoElement.pause();
        videoElement.load();
      }
  
      if (this.QuestionContent.QuestionType === 'MCQImage' || this.QuestionContent.QuestionType === 'RightOrWrongImage') {
        this.QuestionContent.ImageLink = currentQuestionData.ImageLink;
      }
    }
    

    if (this.QuestionContent.QuestionType === 'Ordering') {
      this.formSetup.getAnswersByQuestionID(currentQuestionData.QuestionID).subscribe((response) => {
        
        const result = response.result[0];

        if (result.length === 1 && result[0].AnswerText.includes(',')) {
          const rawAnswers = result[0].AnswerText;
          this.AnswersDto = rawAnswers
            .split(',')
            .map((text: string, index: number) => ({
              AnswerID: index + 1,
              AnswerText: text.trim(),
              Order: index + 1
            }));
        }
        
        if (this.AnswersDto.length > 0 && this.AnswersDto[0].AnswerText.startsWith('Ordering')) {
          this.AnswersDto[0].AnswerText = this.AnswersDto[0].AnswerText.replace('Ordering', '').trim();
        }
        
        this.selectedAnswer = this.AnswersDto.map((a: any) => a.AnswerID);
        this.AnswersDto = this.AnswersDto.sort(() => Math.random() - 0.5);
      });
    }
  }
  
  selectAnswer(answerID: number, questionType: string) {
    if (questionType === 'MultiAnswers') {
      if (this.selectedAnswers.includes(answerID)) {
        this.selectedAnswers = this.selectedAnswers.filter(id => id !== answerID);
      } else {
        this.selectedAnswers.push(answerID);
      }
    }
    this.selectedAnswer = answerID;
  }

  resetOrdering() {
    this.selectedAnswers = [];
    this.selectedAnswer = null;  
    this.loadQuestion(this.currentQuestionIndex);
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }

  postponeQuestion() {
    this.QuestionContent.IsPostponed = true;
    this.FormQuestions.push(this.QuestionContent);

    if (this.postponeCount > 0) {
      this.postponeCount--;
      this.goToNextQuestion();
    }
  }
  

  skipQuestion() {
    this.totalQuestions++;
  
    this.skipThisQuestion = {
      LanguageID: this.QuestionContent.LanguageID,
      QuestionID: this.QuestionContent.QuestionID,
      QuestionLevel: this.QuestionContent.QuestionLevel,
      QuestionType: this.QuestionContent.QuestionType,
      UnitID: this.QuestionContent.UnitID,
    };
  
    this.examService.questionSkip(this.skipThisQuestion).subscribe((response) => {
      const skippedQuestion = response.result[0][0];
      if (skippedQuestion) {
        skippedQuestion.IsSkipped = true;
        this.FormQuestions.push(skippedQuestion); 

        if (this.skipCount > 0) {
          this.skipCount--;
          this.goToNextQuestion();
        }
      }
    });
  }

  goToNextQuestion() {
    this.selectedAnswers = [];
    this.selectedAnswer = null;    
  
    if (this.currentQuestionIndex < this.totalQuestions - 1) {
      this.currentQuestionIndex++;
      this.loadQuestion(this.currentQuestionIndex);
      this.remainingTimePerQuestion = 90; 
  
      if (this.QuestionContent.QuestionType === 'MultiAnswers' && this.selectedAnswers.length > 1) {
        this.selectedAnswers = [];
      }

    } else {
      this.finishExam();
    }
  }
  
  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${this.padZero(minutes)}:${this.padZero(remainingSeconds)}`;
  }

  padZero(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

  finishExam() {
    this.isExamCompleted = true;
    clearInterval(this.timerInterval);
    this.closeModal();
    this.ngOnDestroy();
  }

  startTimer() {
    this.timerInterval = setInterval(() => {
      this.remainingTime--;
      this.remainingTimePerQuestion--;
      if (this.remainingTime <= 0) {
        this.finishExam();
      }
      if (this.remainingTimePerQuestion <= 0) {
        this.goToNextQuestion();
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

}
